import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

interface DialogManagerProps {
    dialogLogoutOpen: boolean;
    setDialogLogoutOpen: (open: boolean) => void;
    onLogout: () => void;
    dialogCloseOpen: boolean;
    setDialogCloseOpen: (open: boolean) => void;
    onConfirmBack: () => void;
    dialogDeleteAccountOpen: boolean;
    setDialogDeleteAccountOpen: (open: boolean) => void;
    onDeleteAccount: () => void;
    isDeleting: boolean;
}

export const DialogManager: FC<DialogManagerProps> = ({
                                                          dialogLogoutOpen,
                                                          setDialogLogoutOpen,
                                                          onLogout,
                                                          dialogCloseOpen,
                                                          setDialogCloseOpen,
                                                          onConfirmBack,
                                                          dialogDeleteAccountOpen,
                                                          setDialogDeleteAccountOpen,
                                                          onDeleteAccount,
                                                          isDeleting,
                                                      }) => {
    return (
        <>
            <Dialog open={dialogLogoutOpen} onClose={() => setDialogLogoutOpen(false)}>
                <DialogTitle>Sair?</DialogTitle>
                <DialogContent>
                    Você tem certeza que deseja sair?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogLogoutOpen(false)} variant="outlined">Cancelar</Button>
                    <Button onClick={onLogout} variant="outlined">Sair</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={dialogCloseOpen} onClose={() => setDialogCloseOpen(false)}>
                <DialogTitle>Pedido em andamento</DialogTitle>
                <DialogContent>
                    Seu pedido ainda não foi concluído, tem certeza que deseja voltar?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogCloseOpen(false)} variant="outlined">Cancelar</Button>
                    <Button onClick={onConfirmBack} variant="outlined">Voltar às Compras</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={dialogDeleteAccountOpen} onClose={() => setDialogDeleteAccountOpen(false)}>
                <DialogTitle>Excluir conta</DialogTitle>
                <DialogContent>
                    Você tem certeza que deseja excluir sua conta? Esta ação não pode ser desfeita.
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogDeleteAccountOpen(false)} variant="outlined" disabled={isDeleting}>Cancelar</Button>
                    <Button
                        onClick={onDeleteAccount}
                        variant="outlined"
                        color="secondary"
                        disabled={isDeleting}
                    >
                        {isDeleting ? 'Excluindo...' : 'Excluir'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};